import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/app/LanguageSwitcher';
import { LogoutButton } from '@/components/auth/LogoutButton';
import { App } from '@/components/app/app';
import { getAppConfig } from '@/lib/utils';

export function HomePage() {
  const appConfig = getAppConfig();
  const { locale } = useParams<{ locale: string }>();
  const { t } = useTranslation();

  return (
    <>
      {/* Desktop Header */}
      <header className="fixed top-0 left-0 z-50 hidden w-full flex-row items-center justify-between p-6 md:flex">
        <div className="flex items-center gap-6">
          <img src="/Decoa_logo_w.svg" alt="Decoa" className="h-7 dark:invert-0 invert" />
          <nav className="flex items-center gap-4">
            <span className="text-foreground text-sm font-medium">
              {t('nav.interview')}
            </span>
            <Link
              to={`/${locale}/dashboard`}
              className="text-muted-foreground hover:text-foreground text-sm font-medium transition-colors"
            >
              {t('nav.dashboard')}
            </Link>
          </nav>
        </div>
        <div className="flex items-center gap-4">
          <LanguageSwitcher />
          <LogoutButton />
        </div>
      </header>

      {/* Mobile Logo */}
      <div className="fixed top-4 left-4 z-50 md:hidden">
        <img src="/Decoa_logo_w.svg" alt="Decoa" className="h-6 dark:invert-0 invert" />
      </div>

      {/* Mobile Navigation */}
      <div className="fixed top-14 left-4 z-50 flex items-center gap-3 md:hidden">
        <span className="text-foreground text-xs font-medium">
          {t('nav.interview')}
        </span>
        <Link
          to={`/${locale}/dashboard`}
          className="text-muted-foreground hover:text-foreground text-xs font-medium transition-colors"
        >
          {t('nav.dashboard')}
        </Link>
      </div>

      {/* Mobile Controls */}
      <div className="fixed top-4 right-4 z-50 flex items-center gap-2 md:hidden">
        <LanguageSwitcher />
        <LogoutButton />
      </div>

      <App appConfig={appConfig} />
    </>
  );
}
